(function() {
    'use strict';
    angular.module('aprima-provider-api').factory('FncPlanRepository', ['AprimaRestangular', 'DeviceSettings', '$q', 'Bridge',
        function (AprimaRestangular, DeviceSettings, $q, Bridge) {
            return {
                getPlans: getPlans,
                inactivatePlan: inactivatePlan,
                saveDefaults: saveDefaults,
                updatePlan: updatePlan
            };

            function getPlans(patientId, visitId) {
                var url = 'patients/' + patientId + '/fnc/' + visitId + '/plan';
                return AprimaRestangular.get({ ignoreCache: true }).all(url).getList();
            }

            function inactivatePlan(plan, patientId) {
                if(DeviceSettings.isPrm) {
                    Bridge.fireEvent('inactivate-diagnosis', {
                        PatientId: patientId,
                        VisitDate: plan.VisitDate,
                        VisitId: plan.VisitUid,
                        VisitDiagnosisId: plan.VisitDiagnosisUid
                    });
                }
                else {
                    var url = 'patients/' + patientId + '/fnc/' + plan.VisitUid + '/inactivatediagnosis/' + plan.VisitDiagnosisUid;
                    AprimaRestangular.get({ ignoreCache: true }).all(url).post()
                        .then(function() {
                            Bridge.fireEvent('inactivated-diagnosis', plan.VisitDiagnosisUid);
                        })
                        .catch(function (error) {
                            console.log('Error inactivating diagnosis: ' + error);
                        });
                }
            }

            function saveDefaults(patientId, visitId, planConfigurationId, configuration)
            {
                var url = 'patients/' + patientId + '/fnc/' + visitId + '/plan/defaults/' + planConfigurationId;
                return AprimaRestangular.get({ ignoreCache: true }).all(url).post(configuration);
            }

            function updatePlan(plan) {
                return plan.put();
            }
        }
    ]);
})();
